import { agentInterviewEpic as epic } from "./epic";
import { agentInterviewsReducer as reducer } from "./reducer";

export const agentInterviewEpic = epic
export const agentInterviewsReducer = reducer
